const theme = {
  colors: {
    primary: '#011D3A', // Bleu
    lightPrimary: '#00254d', // Bleu
    secondary: '#DD3114', // Rouge
    white: '#FFFFFF',
    lightGray: '#F5F5F5',
    darkGray: '#1A1A2E',
    green: '#7CC476'
  }
};

export default theme;